module.exports = __webpack_public_path__ + "img/tratamento-restauradores.f5fafe3a.svg";